import NewOrder from '@/features/notifications/components/HeaderNotification/NewOrder'
import PostponedOrder from '@/features/notifications/components/HeaderNotification/PostponedOrder'
import { useNotificationPressAction } from '@/features/notifications/hooks/useNotificationPressAction'
import NotificationGuard from '@/features/notifications/notification-service-extension-shared/guards/app'
import { Notification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { getNewOrderProps } from '@/features/notifications/utils/getNewOrderProps'
import { getPostponedOrderProps } from '@/features/notifications/utils/getPostponedOrderProps'
import { updateFirebaseReadNotifications } from '@/features/notifications/utils/updateFirebaseReadNotification'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface FactoryProps {
    notification: Notification
    onClose: () => void
}

const Factory: FC<FactoryProps> = ({ notification, onClose }) => {
    const { t } = useTranslation()

    const pressAction = useNotificationPressAction(notification)

    const getProps = <T extends object>(specialProps: T) => ({
        ...specialProps,
        onPress: () => {
            pressAction()

            onClose()

            updateFirebaseReadNotifications(notification)
        },
        onClose,
    })

    if (NotificationGuard.isNewOrder(notification)) {
        return <NewOrder {...getProps(getNewOrderProps(notification, t))} />
    }

    if (NotificationGuard.isPostponedOrder(notification)) {
        return <PostponedOrder {...getProps(getPostponedOrderProps(notification, t))} />
    }
}

export default Factory
